export const OWNER_DATA = {
	companyName: 'NDSOFT sp. z o.o.',
	companyAdress: 'Trakt Królewski 118, 32-800 Mokrzyska',
	vatNo: 'PL8692020677',
	bankName: 'Bank Millenium SA',
	accountNo: '14 1160 2202 0000 0007 0771 0806',
};
